import { Container, Sprite } from 'pixi.js';

import { Shared } from '../App';

export class CharacterPin extends Container
{
    public bg: Sprite;
    public image: Sprite;
    private id: string;

    constructor()
    {
        super();
        this.bg = new Sprite();
        this.bg.anchor.set(0.5);
        this.bg.texture = Shared.assets.getTexture('character-position');
        this.addChild(this.bg);

        this.image = new Sprite();
        this.image.anchor.set(0.5);
        this.addChild(this.image);
        this.id = '';
    }

    public setCharacter(id: string, highlight = true): void
    {
        if (this.id === id) return;
        this.id = id;
        this.renderable = !!id;
        this.bg.tint = highlight ? 0xFFFFFF : 0x333333;
        if (id) this.image.texture = Shared.assets.getTexture(`character-${id}-small`);
    }
}
